const keys = {
  all: ['policies'],
  policy: id => [...keys.all, { policyId: parseInt(id, 10) }],
  policyLinkedItems: id => [...keys.all, 'linked_items', { policyId: parseInt(id, 10) }],
  policyType: id => [...keys.all, 'policy_types', { policyTypeId: parseInt(id, 10) }],
  // Shared trailing segment, so callers that don't know which policies an agent owns can
  // invalidate every cached policy-agent lookup at once.
  policyAgentSegment: 'agent',
  policyAgent: id => [...keys.policy(id), keys.policyAgentSegment]
};

export default keys;
